'use strict'

import CloudDataConnector from '../api.js'
import Plot from './base.js'

export default class PlotFrost extends Plot {
  constructor () {
    super('frost')
  }

  async dataFunction (controller) {
    // Get data from API
    const response = await new CloudDataConnector().getFrost(controller.uiElements.station.val())
    const height = controller.uiParams.height

    // Compute plot data
    const data = response.sort((left, right) => left.date < right.date ? -1 : (left.date > right.date ? 1 : 0))
    const dataPoints = data.map(item => item.n_frost_day)
    const xaxis = data.map(item => item.date)

    // Return elements to give to Plotly
    return {
      data: [
        {
          x: xaxis,
          y: dataPoints,
          type: 'line+marker',
          marker: {
            color: '#00AFD3'
          }
        }
      ],
      layout: {
        xaxis: { title: 'Année', autotick: false },
        yaxis: { title: 'Nombre de jour de gel' },
        margin: { t: 0 },
        height
      }
    }
  }
}
